import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.title',
    defaultMessage: 'EDIT SIMULATION',
  },
  back: {
    id: 'simulated.correction.back',
    defaultMessage: 'Back',
  },
  correctionMethod: {
    id: 'simulated.correction.correctionMethod',
    defaultMessage: 'CORRECTION METHOD',
  },
  choiceInfo: {
    id: 'simulated.correction.choiceInfo',
    defaultMessage: 'Select the correction method',
  },
  sendCardsSubtitle: {
    id: 'simulated.correction.sendCardsSubtitle',
    defaultMessage: 'Sending scanned answer cards',
  },
  sendCardsInfo: {
    id: 'simulated.correction.sendCardsInfo',
    defaultMessage:
      'In this method, the answer cards must be scanned by the school itself and then loaded into the system via the button below.',
  },
  loadCardsButton: {
    id: 'simulated.correction.loadCardsButton',
    defaultMessage: 'Upload answer card files',
  },
  correctionCardSubtitle: {
    id: 'simulated.correction.correctionCardSubtitle',
    defaultMessage: 'Make correction using Simplificas',
  },
  correctionCardInfo: {
    id: 'simulated.correction.correctionCardInfo',
    defaultMessage: "Correct answer cards using your phone's camera and app Simplifies from SM.",
  },
  correctionCardButton: {
    id: 'simulated.correction.correctionCardButton',
    defaultMessage: 'Instructions',
  },
  class: {
    id: 'simulated.correction.class',
    defaultMessage: 'Class',
  },
  school: {
    id: 'simulated.correction.school',
    defaultMessage: 'School',
  },
  forbidden: {
    id: 'simulated.correction.forbidden',
    defaultMessage: 'Content not available.',
  },
  problemsFound: {
    id: 'simulated.correction.problemsFound',
    defaultMessage: 'Problems found',
  },
  see: {
    id: 'simulated.correction.see',
    defaultMessage: 'See',
  },
  upload: {
    id: 'simulated.correction.upload',
    defaultMessage: 'Upload',
  },
  audit: {
    id: 'simulated.correction.audit',
    defaultMessage: 'Audit',
  },
  needClickBefore: {
    id: 'simulated.correction.needClickBefore',
    defaultMessage: 'You need to select a class before',
  },
  confirm: {
    id: 'simulated.correction.confirm',
    defaultMessage: 'Confirm',
  },
  confirmRemove: {
    id: 'simulated.correction.confirmRemove',
    defaultMessage:
      'Are you sure you want to remove this answer card? This operation is irreversible.',
  },
  removeTitle: {
    id: 'simulated.correction.removeTitle',
    defaultMessage: 'REMOVING ANSWER CARD',
  },
  close: {
    id: 'simulated.correction.close',
    defaultMessage: 'Close',
  },
  finishAndRequestReports: {
    id: 'simulated.correction.finishAndRequestReports',
    defaultMessage: 'Finalize and request reports',
  },
  finishedAndReportRequested: {
    id: 'simulated.correction.finishedAndReportRequested',
    defaultMessage: 'Finished and report Requested',
  },
  hits: {
    id: 'simulated.correction.editModal.hits',
    defaultMessage: 'hits',
  },
  hitLabel: {
    id: 'simulated.correction.editModal.hitLabel',
    defaultMessage: 'hit',
  },
  questionsLabel: {
    id: 'simulated.correction.editModal.questionsLabel',
    defaultMessage: 'of {total} questions',
  },
  restore: {
    id: 'simulated.correction.editModal.restore',
    defaultMessage: 'Restore',
  },
  remove: {
    id: 'simulated.correction.editModal.remove',
    defaultMessage: 'Remove',
  },
  save: {
    id: 'simulated.correction.editModal.save',
    defaultMessage: 'Save editions',
  },
  warning: {
    id: 'simulated.correction.editModal.warning',
    defaultMessage:
      'Problem found - Inappropriate reading. review the file because the system clipping may not have been able to identify correctly',
  },
  answerCard: {
    id: 'simulated.correction.editModal.answerCard',
    defaultMessage: 'Response Card',
  },
  previewResult: {
    id: 'simulated.correction.editModal.previewResult',
    defaultMessage: 'Previous Result',
  },
  answers: {
    id: 'simulated.correction.editModal.answers',
    defaultMessage: 'Answers',
  },
  seeHits: {
    id: 'simulated.correction.editModal.seeHits',
    defaultMessage: 'See hits',
  },
  searchStudent: {
    id: 'simulated.correction.editModal.searchStudent',
    defaultMessage: 'Search student ...',
  },
  languageOption: {
    id: 'simulated.correction.editModal.languageOption',
    defaultMessage: 'Modern foreign language option',
  },
  englishLanguage: {
    id: 'simulated.correction.editModal.englishLanguage',
    defaultMessage: 'English language',
  },
  spanishLanguage: {
    id: 'simulated.correction.editModal.spanishLanguage',
    defaultMessage: 'Spanish language',
  },
  noStudentOnList: {
    id: 'simulated.correction.editModal.noStudentOnList',
    defaultMessage: 'Attention, due to inconsistency in the information, the student was not found',
  },
  auditRequiredInfo: {
    id: 'simulated.correction.auditRequiredInfo',
    defaultMessage: 'There are answer cards that require auditing for validation. While audits are not performed, the reports of these students will remain blocked.',
  },
  cardsNotLoadedInfo: {
    id: 'simulated.correction.cardsNotLoadedInfo',
    defaultMessage: 'Some students still do not have answer cards loaded in the system. Check the submission of the cards to ensure complete participation in the evaluation.',
  },
  auditPendingTitle: {
    id: 'simulated.correction.auditPendingTitle',
    defaultMessage: 'PENDING AUDIT',
  },
  studentsWithoutCardsTitle: {
    id: 'simulated.correction.studentsWithoutCardsTitle',
    defaultMessage: 'STUDENTS WITHOUT LOADED CARDS',
  },
  totalStudents: {
    id: 'simulated.correction.totalStudents',
    defaultMessage: 'Total students',
  },
});
